import { httpClient } from 'src/libraries/http.library';
import {
  NotificationListSchema,
  NotificationCountSchema,
} from 'src/models/notification.model';

const client = httpClient();

const services = {
  listGET: async (params) => {
    return client.get('/notifications', params, NotificationListSchema);
  },

  countGET: async () => {
    return client.get('/notifications/count', {}, NotificationCountSchema);
  },
};

export default services;
